import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Stage1 from './views/Stage1.vue'
import Stage2 from './views/Stage2.vue'
import Stage3 from './views/Stage3.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: "*",
            redirect: '/login'
        },
        {
            path: '/stage1',
            name: 'stage1',
            component: Stage1,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/stage2',
            name: 'stage2',
            component: Stage2,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/stage3',
            name: 'stage3',
            component: Stage3,
            meta: {
                requiresAuth: true
            }
        }
    ]
})
